<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Leaderboard</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
        class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
      >
        <button class="button text-white shadow-md mr-2" v-for="w in workshops" @click="selectWorkshop(w.wid)" :class="{'bg-theme-10': selectedIndex == w.wid, 'bg-theme-27': selectedIndex != w.wid}">
          {{ w.name }}
        </button>
        <div class="dropdown">
          <button
            class="dropdown-toggle button px-2 box text-gray-700 dark:text-gray-300"
          >
            <span class="w-5 h-5 flex items-center justify-center">
              <PlusIcon class="w-4 h-4" />
            </span>
          </button>
          <div class="dropdown-box w-40">
            <div class="dropdown-box__content box dark:bg-dark-1 p-2">
              <a
                href=""
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
              >
                <UsersIcon class="w-4 h-4 mr-2" /> Add Group
              </a>
              <a
                href=""
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
              >
                <MessageCircleIcon class="w-4 h-4 mr-2" /> Send Message
              </a>
            </div>
          </div>
        </div>
        <div class="hidden md:block mx-auto text-gray-600">
          Showing {{ data.length }} entries
        </div>
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-56 relative text-gray-700 dark:text-gray-300">
            <input
              @input="search"
              type="text"
              class="input w-56 box pr-10 placeholder-theme-13"
              placeholder="Search..."
            />
            <SearchIcon
              class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
            />
          </div>
        </div>
      </div>
      <!-- BEGIN: Users Layout -->
      <div class="col-span-12 text-center text-lg" v-if="workshops.length > 0 && selectedIndex == -1">
        Select a workshop!
      </div>
      <div
        v-for="(r, k) in data"
        :key="r.session_id"
        class="intro-y col-span-12 md:col-span-6"
      >
        <div class="box">
          <div class="flex flex-col lg:flex-row items-center p-5">
            <div class="w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1">
<!--              <img-->
<!--                alt="Midone Tailwind HTML Admin Template"-->
<!--                class="rounded-full"-->
<!--                :src="require(`@/assets/images/${faker.photos[0]}`)"-->
<!--              />-->
            </div>
            <div
              class="lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
            >
              <strong>{{ k+1 }}#    </strong>
              <a href="" class="font-medium">{{ r.username }}</a>
<!--              <a href="" class="font-medium">{{ r.total_score }}</a>-->
              <div class="text-gray-600 text-xs">{{ r.email }}</div>
            </div>
            <div class="flex mt-4 lg:mt-0">
              <button class="button button--sm text-white bg-theme-1 mr-2" @click="contact(r.email)">
                {{ r.total_score }}
              </button>
              <button class="button button--sm text-white bg-theme-34 ml-2" @click="mark(r.session_id, (k+1))">
                See Marks
              </button>
<!--              <button-->
<!--                class="button button&#45;&#45;sm text-gray-700 border border-gray-300 dark:border-dark-5 dark:text-gray-300"-->
<!--              >-->
<!--                Profile-->
<!--              </button>-->
            </div>
          </div>
        </div>
      </div>

      <!-- BEGIN: Users Layout -->
      <!-- END: Pagination -->
<!--      <div-->
<!--        class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center"-->
<!--      >-->
<!--        <ul class="pagination">-->
<!--          <li>-->
<!--            <a class="pagination__link" href="">-->
<!--              <ChevronsLeftIcon class="w-4 h-4" />-->
<!--            </a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a class="pagination__link" href="">-->
<!--              <ChevronLeftIcon class="w-4 h-4" />-->
<!--            </a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a class="pagination__link" href="">...</a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a class="pagination__link" href="">1</a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a class="pagination__link pagination__link&#45;&#45;active" href="">2</a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a class="pagination__link" href="">3</a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a class="pagination__link" href="">...</a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a class="pagination__link" href="">-->
<!--              <ChevronRightIcon class="w-4 h-4" />-->
<!--            </a>-->
<!--          </li>-->
<!--          <li>-->
<!--            <a class="pagination__link" href="">-->
<!--              <ChevronsRightIcon class="w-4 h-4" />-->
<!--            </a>-->
<!--          </li>-->
<!--        </ul>-->
<!--        <select class="w-20 input box mt-3 sm:mt-0">-->
<!--          <option>10</option>-->
<!--          <option>25</option>-->
<!--          <option>35</option>-->
<!--          <option>50</option>-->
<!--        </select>-->
<!--      </div>-->
      <!-- END: Pagination -->
    </div>
    <t-modal
        v-model="isModal"
    >
      <div class="flex flex-row m-auto bg-gradient-to-r from-blue-700 via-blue-800 to-blue-900 p-6 gap-8 rounded-lg border-2 border-blue-100">
        <div class="my-auto">
          <div class="text-lg text-blue-300">Score</div>
          <div class="text-4xl text-purple-100">{{ getScore() }}</div>
        </div>
        <div class="float-right">
          <div class="text-lg text-blue-300">Rank</div>
          <div class="text-4xl text-purple-100">{{ rank }}</div>
        </div>
      </div>
      <table class="table mt-5">
        <thead>
        <tr class="bg-gray-700 dark:bg-dark-1 text-white">
          <th class="border-b-2 dark:border-dark-5 border-gray-600 whitespace-nowrap">#</th>
          <th class="border-b-2 dark:border-dark-5 border-gray-600 whitespace-nowrap">Question</th>
          <th class="border-b-2 dark:border-dark-5 border-gray-600 whitespace-nowrap">Answer</th>
          <th class="border-b-2 dark:border-dark-5 border-gray-600 whitespace-nowrap">Expected Answer</th>
          <th class="border-b-2 dark:border-dark-5 border-gray-600 whitespace-nowrap">Score</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(r, i) in answers.records" :key="r.id" :class="{'bg-green-200':r.score>0, 'text-green':true,'bg-red-200':r.score<1}">
          <td class="border-b dark:border-dark-5">{{ i+1 }}</td>
          <td class="border-b dark:border-dark-5">{{ r.question_description }}</td>
          <td class="border-b dark:border-dark-5">{{ r.user_answers }}</td>
          <td class="border-b dark:border-dark-5">{{ r.actual_answer }}</td>
          <td class="border-b dark:border-dark-5">
            <input
                v-model="r.score"
                type="text"
                class="input w-56 box pr-10 placeholder-theme-13"
                placeholder="Search..."
            />
<!--            {{ r.score }}-->
          </td>
        </tr>
        </tbody>
      </table>
      <template v-slot:footer>
        <div class="flex justify-between">
          <button type="button" @click="isModal=false">
            Cancel
          </button>
          <button type="button" @click="isModal=false">
            OK
          </button>
        </div>
      </template>
    </t-modal>
  </div>
</template>

<script>
import axios from "axios"
export default {
  data() {
    return {
      dashboardInfo: [],
      workshops: [],
      registrants: [],
      selectedIndex: -1,
      data: [],
      answers: {records:[]},
      isModal: false,
      rank: 0
    }
  },
  methods: {
    getProfileInfo() {
      this.$upskill.trainerDashboard().then(res => {
        this.dashboardInfo = res.data
        this.getKeys();
      });
    },
    getRegistrants(id) {
      this.$upskill.regs(id).then(res => {
        this.registrants = res.data.data
      })
    },
    selectWorkshop(id) {
      this.selectedIndex = id
      this.getRegistrants(id)
    },
    search(e) {

    },
    getKeys() {
      let arr = [];
      Object.keys(this.dashboardInfo.data).forEach(k => {
        arr.push({ wid: k, name: this.dashboardInfo.data[k].name });
      });
      this.workshops = arr;
    },
    contact(email) {
      window.open("mailto:"+email, "_blank")
    },
    getSubmissions(id) {
      this.$upskill.submissions(id).then(res => {
        this.data = res.data.data
        this.data = this.data.sort((a,b) => parseInt(b.total_score) - parseInt(a.total_score))
      })
    },
    mark(id, rank) {
      this.rank = rank
      this.isModal = true
      this.$upskill.mark(id).then(res => {
        this.answers = res.data
      })
    },
    getScore() {
      let sum =0
      this.answers.records.forEach(o => {
        sum += o.score
      })
      return sum + " / " + this.answers.quiz_score
    }
  },
  created() {
    this.getProfileInfo()
    let rid = this.$route.params.quiz_id
    this.getSubmissions(rid)
  }
}
</script>
